import React from "react";
import Account from "../../components/Account";
import { AccountType } from "../../utils/constants";

const ACCOUNT_TYPE_LABELS = {
  [AccountType.Commercial]: "Commercial",
  [AccountType.Retail]: "Retail",
  [AccountType.Guest]: "Guest",
};

const AccountPage = ({ genericPageContent }) => {
  const accountTypeId = String(genericPageContent?.accountType ?? "").toLowerCase();

  return (
    <Account
      accountType={ACCOUNT_TYPE_LABELS[accountTypeId] ?? "Not set"}
      priceCategory={genericPageContent?.customerCategory ?? "Not set"}
    />
  );
};

export default AccountPage;
